const Loading: React.FC<{}> = () => {
  return (
    <div className="flex justify-content-center mb-4">
      <div className="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default Loading;
